/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
import SkeletonIcon from '../SkeletonIcon/SkeletonIcon.js';

const AISkeletonIcon = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const AISkeletonIconClasses = cx(className, {
    [`${prefix}--skeleton__icon--ai`]: true
  });
  return /*#__PURE__*/React__default.createElement(SkeletonIcon, _extends({
    className: AISkeletonIconClasses
  }, rest));
};
AISkeletonIcon.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * The CSS styles.
   */
  style: PropTypes.object
};

export { AISkeletonIcon as default };
